import type { BodyMeasurementRecord } from '~/powersync/generated/schema';

/**
 * Input for creating a body measurement. Unlike most create inputs, `id` is
 * **included** — the caller supplies it: a deterministic UUID v5 for imported
 * health-store readings (so re-imports collide on the primary key) and a random
 * UUID for manual entries. Only the server-managed timestamps are omitted.
 */
export type CreateBodyMeasurementInput = Omit<
  BodyMeasurementRecord,
  'createdAt' | 'updatedAt' | 'deletedAt'
>;
